import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initAnalytics } from "@/lib/analytics";
import { hasConsent } from "@/lib/tracking";
import { CookieBanner } from "@/components/site/CookieBanner";
import CompletePayment from "@/pages/CompletePayment";
import TermsPage from "@/pages/TermsPage";
import Contact from "@/pages/Contact";
import Messages from "@/pages/admin/Messages";
import Giveaway from "@/pages/admin/Giveaway";
import { GiveawayPopup } from "@/components/site/GiveawayPopup";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Proposal from "@/pages/Proposal";
import Policy from "@/pages/Policy";
import Register from "@/pages/Register";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Players from "@/pages/admin/Players";
import PlayerDetail from "@/pages/admin/PlayerDetail";
import Payments from "@/pages/admin/Payments";
import Emails from "@/pages/admin/Emails";
import AuditLog from "@/pages/admin/AuditLog";
import Staff from "@/pages/admin/Staff";
import Settings from "@/pages/admin/Settings";

function App() {
  useEffect(() => {
    initAnalytics(hasConsent());
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/proposal" element={<Proposal />} />
            <Route path="/privacy" element={<Policy kind="privacy" />} />
            <Route path="/giveaway-terms" element={<Policy kind="giveaway-terms" />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/refund-policy" element={<Policy kind="refund-policy" />} />
            <Route path="/child-safety" element={<Policy kind="child-safety" />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/register" element={<Register />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/complete-payment" element={<CompletePayment />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Overview />} />
              <Route path="players" element={<Players />} />
              <Route path="players/:id" element={<PlayerDetail />} />
              <Route path="payments" element={<Payments />} />
              <Route path="emails" element={<Emails />} />
              <Route path="messages" element={<Messages />} />
              <Route path="giveaway" element={<Giveaway />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="staff" element={<Staff />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
          <CookieBanner />
          <GiveawayPopup />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" offset={88} />
    </div>
  );
}

export default App;
